import React, { useState, useRef } from "react";
import { Box, OutlinedInputProps, TextFieldProps } from "@material-ui/core";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import moment, { Moment } from "moment";
import { PickerProps } from "antd/lib/date-picker/generatePicker";

import "./custom-date.style.css";
import { InputField } from "../input-field/InputField";
import { useStyles } from "./InputDate.style";

export interface InputDateProps {
  maxDate?: string;
  minDate?: string;
  onDateChange?: (name: string, dateString: string) => void;

  inputProps: OutlinedInputProps | TextFieldProps;
  pickerProps: PickerProps<Moment>;
}

export function InputDate(props: InputDateProps) {
  const classes = useStyles(props);
  // Props
  const { inputProps, pickerProps, onDateChange, maxDate, minDate } = props;
  // Ref
  const inputRef = useRef(null);
  // State
  const [open, setOpen] = useState(false);
  const [localValue, setLocalValue] = useState(inputProps.value);

  const handleDateChange = (dateString: string) => {
    inputRef.current.blur();
    setLocalValue(dateString);
    setOpen(false);

    if (onDateChange !== null && onDateChange !== undefined) {
      onDateChange(inputProps.name, dateString);
    }
  };

  const disabledDate = (current) => {
    if (maxDate !== null) {
      // Can not select days after today and today
      return (
        current && current > moment(maxDate, (props as any).format).endOf("day")
      );
    }

    if (minDate !== null) {
      // Can not select days before today and today
      return (
        current && current < moment(minDate, (props as any).format).endOf("day")
      );
    }

    return false;
  };

  return (
    <Box className={classes.root}>
      <InputField
        {...inputProps}
        value={localValue}
        inputRef={inputRef}
        type="text"
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onChange={(event) => handleDateChange(event.currentTarget.value)}
      />
      <div className={classes.hiddenPicker}>
        <DatePicker
          {...pickerProps}
          defaultValue={
            inputProps.value
              ? moment(inputProps.value, (props as any).format)
              : null
          }
          open={open}
          bordered={false}
          popupStyle={{
            textAlign: "center",
            fontSize: "13px",
            color: "#263238",
            fontWeight: 600,
          }}
          style={{
            height: "0px",
            width: "100%",
            border: "none",
            borderRadius: "0px",
            cursor: "pointer",
            fontSize: "2px",
            margin: "0",
            padding: "0",
            transition: "all 0.2s",
          }}
          onChange={(date, strDate) => handleDateChange(strDate)}
          disabledDate={disabledDate}
        />
      </div>
    </Box>
  );
}

InputDate.defaultProps = {
  maxDate: null,
};
